import type { BlobInfo } from '@/engine/app/CaseDataProvider';
import type { CaseInfo } from '@/engine/app/CaseInfoApi';
import type { EntityTable, Table } from 'dexie';
import { Dexie } from 'dexie';
import { injectable } from 'inversify';

interface Cases extends CaseInfo {
  savedPackages: Array<string>;
}

interface PackageFiles {
  packageId: string;
  files: Array<string>;
}

interface Blobs extends BlobInfo {
  packageId: string;
}

export interface Schema {
  cases: EntityTable<Cases, 'caseId'>;
  packageFiles: EntityTable<PackageFiles, 'packageId'>;
  blobs: Table<Blobs, [string, string]>;
}

@injectable()
export class OfflineDB {
  private _db?: Dexie & Schema;

  public constructor() {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this.init();
  }

  public async init(): Promise<void> {
    this._db = new Dexie('offline') as Dexie & Schema;
    this._db.version(1).stores({
      cases: 'caseId',
      packageFiles: 'packageId',
      blobs: '[packageId+descriptor]'
    });
    await this._db.open();
  }

  public get schema(): Dexie & Schema {
    if (!this._db) {
      throw new Error('OfflineDB not initialized');
    }
    return this._db;
  }
}
